/**
 * After a deploy, a tab that was already open still asks for the page files of the old version,
 * which are gone ("Failed to fetch dynamically imported module"). Loading the page again gets
 * the new version.
 */
const RELOADED_AT = 'tk-reloaded-for-update';

export function isOldVersionError(error: unknown): boolean {
  const text = error instanceof Error ? `${error.name} ${error.message}` : String(error);
  return /failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module|unable to preload css/i.test(
    text,
  );
}

/**
 * Loads the page again, once: never twice within 30 seconds (so a real outage never loops).
 * False when it did not (then the page shows a Reload button).
 */
export function reloadForUpdate(): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOADED_AT) ?? 0);
    if (Date.now() - last < 30_000) return false;
    sessionStorage.setItem(RELOADED_AT, String(Date.now()));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}
